import { SignInType } from '~constants/SignInTypeEnum';

export enum TaggingEventSourceType {
    ACCOUNT = 'account',
    CHECKOUT_SIGN_IN = 'checkout sign-in',
    CHECKOUT_SIGN_UP = 'checkout sign-up',
    GUEST_CHECKOUT = 'guest checkout',
    KAKAO_GIFT = 'kakaogift',
    SSG = 'ssg',
    IN_STORE = 'in-store'
}

export enum SignUpTaggingEventType {
    PARTIAL = 'partial',
    COMPLETE = 'complete',
    USER_EXISTING = 'user existing',
    VALIDATION_FAILURE = 'validation failure',
    API_ERROR_OR_IP_LOCK = 'API error / IP lock'
}

// TODO: sign-in type -> provider
export type TaggingEventProviderType = 'standard' | Omit<`${SignInType}`, 'guest'>;

export const eventTag = {
    SIGN_UP_SUCCESSFUL: 'iam.registration',
    SIGN_UP_FAILED: 'iam.registrationFailed',
    SIGN_IN_SUCCESSFUL: 'iam.signIn',
    SIGN_IN_FAILED: 'iam.signInFailed',
    ACCOUNT_ROUTE: 'iam.accountRoute',
    EMAIL_PROMOTION: 'iam.emailSignup'
} as const;

type TaggingEventName = typeof eventTag[keyof typeof eventTag];

interface IEventPayload {
    source: TaggingEventSourceType;
    provider: TaggingEventProviderType;
}

interface ISignInSuccessfulPayload extends IEventPayload {
    rememberMe?: boolean;
    userId?: number;
}

interface ISignInFailedPayload extends IEventPayload {
    type: string;
}

interface ISignUpFailedPayload extends IEventPayload {
    type: SignUpTaggingEventType;
}

interface ISignUpSuccessfulPayload extends IEventPayload {
    type: SignUpTaggingEventType;
    userId?: number;
}
interface IAccountRoutePayload {
    route: string;
}
interface IEmailSignupPayload {
    event_name: string,
    last_source: string
    opt_in_state: string
}
interface EventPayloadMap {
    [eventTag.SIGN_UP_SUCCESSFUL]: ISignUpSuccessfulPayload;
    [eventTag.SIGN_UP_FAILED]: ISignUpFailedPayload;
    [eventTag.SIGN_IN_SUCCESSFUL]: ISignInSuccessfulPayload;
    [eventTag.SIGN_IN_FAILED]: ISignInFailedPayload;
    [eventTag.ACCOUNT_ROUTE]: IAccountRoutePayload;
    [eventTag.EMAIL_PROMOTION]: IEmailSignupPayload;
}

export type GetSignUpEventDataParameterType = {
    userId?: number;
    type?: SignUpTaggingEventType;
};

export const emitAnalyticsEvent = <T extends TaggingEventName>(
    eventName: T,
    eventData: EventPayloadMap[T]
) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail: eventData }));
};
